import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProtoListRequest, ProtoResponse } from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { ColumnData } from './models/column-data';
import { Report, ReportSort } from './models/report';
import {
    DateRange,
    FilterBy,
    ReportType,
    ReportStatus,
    CompanyRole
} from './models/reports.constants';
import { ReportCenterApiService } from './report-center-api';

@Injectable()
export class SetCompanyReportService extends ReportCenterApiService<
    SetCompanyReportRequest,
    SetCompanyReportResponse
> {
    public requestType = SetCompanyReportRequest;
    public responseType = SetCompanyReportResponse;
    public endpointName = 'v1/report';
    public serviceName = 'reportCenter';
    public usePascalForUrl = false;

    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}

export class SetCompanyReportRequest extends ProtoListRequest {
    public companyRoleId: number;
    public dateRange: DateRange;
    public description: string;
    public enableFooterTotals: boolean;
    public endDate: string;
    public filterBy: FilterBy;
    public isGlobal: boolean;
    public name: string;
    public reportType: ReportType;
    public sort: ReportSort[];
    public startDate: string;
    public status: ReportStatus;
    public id: number;

    constructor(params?: Partial<SetCompanyReportRequest>) {
        super();
        this.companyRoleId = params?.companyRoleId || CompanyRole.Seller; // hard code to 2 (scf seller) for now. Need to get value from legal entity eventually.
        this.dateRange = params?.dateRange || null;
        this.description = params?.description || '';
        this.enableFooterTotals = params?.enableFooterTotals || false;
        this.endDate = params?.endDate || null;
        this.filterBy = params?.filterBy || null;
        this.isGlobal = params?.isGlobal || false;
        this.name = params?.name || null;
        this.reportType = params?.reportType || null;
        this.sort = params?.sort || [];
        this.startDate = params?.startDate || null;
        this.status = params?.status || ReportStatus.All;
        this.id = params?.id || 0;
    }
}

// back end return needs to be improved
export class SetCompanyReportResponse extends ProtoResponse<Report> {
    public code: number;
    public message: string;
    public columns: ColumnData[];
    public companyRoleId: number;
    public createdDate: string;
    public dateRange: string;
    public dateRangeDisplay: string;
    public description: string;
    public enableFooterTotals: boolean;
    public endDate: string;
    public filterBy: FilterBy;
    public id: number;
    public isGlobal: boolean;
    public lastRun: string;
    public modifiedDate: string;
    public name: string;
    public reportType: ReportType;
    public sort: ReportSort[];
    public startDate: string;
    public status: ReportStatus;
    public userName: string;

    constructor(obj?: Partial<SetCompanyReportResponse>) {
        super();
        this.code = obj?.code || 200;
        this.message = obj?.message || '';
        this.columns = obj?.columns || [];
        this.companyRoleId = obj?.companyRoleId || 2;
        this.createdDate = obj?.createdDate || null;
        this.dateRange = obj?.dateRange || null;
        this.dateRangeDisplay = obj?.dateRangeDisplay;
        this.description = obj?.description || null;
        this.enableFooterTotals = obj?.enableFooterTotals || false;
        this.endDate = obj?.endDate || null;
        this.filterBy = obj?.filterBy || null;
        this.id = obj?.id || 0;
        this.isGlobal = obj?.isGlobal || false;
        this.lastRun = obj?.lastRun || null;
        this.modifiedDate = obj?.modifiedDate || null;
        this.name = obj?.name || null;
        this.reportType = obj?.reportType || null;
        this.sort = obj?.sort || [];
        this.startDate = obj?.startDate || null;
        this.status = obj?.status || ReportStatus.All;
        this.userName = obj?.userName || null;
    }
}
